import { createStoreWithSelectors } from 'common/util/zustand';
import { create } from 'zustand';
import { subscribeWithSelector } from 'zustand/middleware';
export const lotsStore = create(subscribeWithSelector((set) => ({
    lots: [],
    setLots: (lots) => {
        set(() => ({ lots: lots }));
    },
    filteredLots: [],
    setFilteredLots: (filteredLots) => {
        set(() => ({ filteredLots: filteredLots }));
    }
})));
const useLotsStore = createStoreWithSelectors(lotsStore);
export default useLotsStore;
